module.exports = __webpack_public_path__ + "img/1st-school-day-min.2ea64e28.png";